
import { Options, Vue } from "vue-class-component";
import DetailLayout from "@/app/ui/layout/detail-layout.vue";
import CardReport from "./component/card-report.vue";
import ModalDownload from "./component/modal-download.vue";
import DownloadRequest from "@/app/ui/components/widget-download-request/index.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { ReportController } from "@/app/ui/controllers/ReportController";
import { FlagsPermissionReport } from "@/feature-flags/flag-report";

@Options({
  components: {
    DetailLayout,
    CardReport,
    ModalDownload,
    DownloadRequest
  }
})
export default class Report extends Vue {
  //   Search
  searchValue = "";
  _onGetSearch(value: string) {
    if (!value || value.length >= 3) {
      this.searchValue = value;
    }
  }

  onSearch(value: string) {
    this._onGetSearch(value);
  }
  onClearSearch() {
    this.searchValue = "";
    this._onGetSearch("");
  }

  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }

  // get account type
  get isInternal() {
    return (
      this.dataProfile.isInternalAccount || this.dataProfile.isCustomerService
    );
  }
  get isClient() {
    return this.dataProfile.isAllClient;
  }
  get isPos() {
    return this.dataProfile.isPosAccount;
  }
  get isConsole() {
    return this.dataProfile.isConsoleAccount;
  }
  get isSubConsole() {
    return this.dataProfile.isSubConsoleAccount;
  }
  get isPosParent() {
    return this.dataProfile.isPosParentAccount;
  }
  get isPosBranch() {
    return this.dataProfile.isSubConsoleAccount;
  }

  created() {
    this.onGetReportList();
  }
  tmpReportListData: Array<any> = [];
  get reportListData() {
    if (this.searchValue && this.searchValue.length >= 3) {
      const filterData: Array<any> = [];

      for (const data of this.tmpReportListData) {
        const isExist = filterData.find((item) => item.title === data.title);
        const res = data.detail.filter(
          (report: any) =>
            report.title
              .toLowerCase()
              .includes(this.searchValue.toLowerCase()) && report.permission
        );

        if (!isExist && res.length) {
          filterData.push({ ...data, detail: res, totalCard: res.length });
        }
      }

      return filterData;
    }

    return this.tmpReportListData;
  }

  get reportStt() {
    return [
      {
        title: this.$t("report.cards.titleSttReport"),
        description: "STT",
        displayLabel: this.$t("report.cards.descStt"),
        color: "#B82025",
        permission: FlagsPermissionReport.laporan_download_stt.isEnabled()
      },
      {
        title: this.$t("report.cards.titleSttClient"),
        description: "STT Client",
        displayLabel: this.$t("report.cards.descSttClient"),
        color: "#0984e3",
        permission: FlagsPermissionReport.permission_report_view_stt_client.isEnabled()
      },
      {
        title: this.$t("report.cards.titleSttManual"),
        description: "STT Manual",
        displayLabel: this.$t("report.cards.descSttManual"),
        color: "#C8BBA7",
        permission: FlagsPermissionReport.laporan_download_stt_manual.isEnabled()
      },
      {
        title: this.$t("report.cards.titlePembatalanStt"),
        description: "Pembatalan STT",
        displayLabel: this.$t("report.cards.descPembatalanStt"),
        color: "#93E0F0",
        permission: FlagsPermissionReport.laporan_download_pembatalan_stt.isEnabled()
      },
      {
        title: this.$t("report.cards.titleFpr"),
        description: "FPR",
        displayLabel: this.$t("report.cards.descFpr"),
        color: "#1B48A0",
        permission: false
      },
      {
        title: this.$t("report.cards.titleCod"),
        description: "COD",
        displayLabel: this.$t("report.cards.descCod"),
        color: "#BC9AFD",
        permission: false
      }
    ];
  }

  get reportFinance() {
    return [
      {
        title: this.$t("report.cards.titleTopUp"),
        description: "Top Up",
        displayLabel: this.$t("report.cards.descTopUp"),
        color: "#93E0F0",
        permission: FlagsPermissionReport.laporan_download_top_up.isEnabled()
      },
      {
        title: this.$t("report.cards.titlePendapatan"),
        description: "Pendapatan",
        displayLabel: this.$t("report.cards.descPendapatan"),
        color: "#7ACB90",
        permission: false
      },
      {
        title: this.$t("report.cards.titlePembayaran"),
        description: "Pembayaran",
        displayLabel: this.$t("report.cards.descPembayaran"),
        color: "#FF7474",
        permission: false
      },
      {
        title: this.$t("report.cards.titleTransaksi"),
        description: "Transaksi",
        displayLabel: this.$t("report.cards.descTransaksi"),
        color: "#FFCB01",
        permission: false
      },
      {
        title: this.$t("report.cards.titleReferralPos"),
        description: "Referral POS",
        displayLabel: this.$t("report.cards.descReferralPos"),
        color: "#6257BA",
        permission: FlagsPermissionReport.laporan_download_referral_pos.isEnabled()
      },
      {
        title: this.$t("report.cards.titleBonusKomisi"),
        description: "Bonus Komisi",
        displayLabel: this.$t("report.cards.descBonusKomisi"),
        color: "#51B6D5",
        permission: FlagsPermissionReport.report_bonus_komisi.isEnabled()
      },
      {
        title: this.$t("report.cards.titleKomisiAffiliate"),
        description: "Komisi Affiliate",
        displayLabel: this.$t("report.cards.descKomisiAffiliate"),
        color: "#7ACB90",
        permission: FlagsPermissionReport.laporan_download_komisi_affiliate.isEnabled()
      },
      {
        title: this.$t("report.cards.titleKomisiPosInduk"),
        description: "Komisi POS Induk",
        displayLabel: this.$t("report.cards.descKomisiPosInduk"),
        color: "#51B6D5",
        permission: FlagsPermissionReport.laporan_download_komisi_pos_induk.isEnabled()
      }
    ];
  }

  get reportDeliveryPartOne() {
    return [
      {
        title: this.$t("report.cards.titleTransit"),
        description: "Transit",
        displayLabel: this.$t("report.cards.descTransit"),
        color: "#F09035",
        permission: false
      },
      {
        title: this.$t("report.cards.titleMisroute"),
        description: "Misroute",
        displayLabel: this.$t("report.cards.descMisroute"),
        color: "#2468F6",
        permission: FlagsPermissionReport.laporan_download_misroute.isEnabled()
      },
      {
        title: this.$t("report.cards.titleShortland"),
        description: "Shortland",
        displayLabel: this.$t("report.cards.descShortland"),
        color: "#00875A",
        permission: FlagsPermissionReport.laporan_download_shortland.isEnabled()
      },
      {
        title: this.$t("report.cards.titlePengiriman"),
        description: "Pengiriman",
        displayLabel: this.$t("report.cards.descPengiriman"),
        color: "#BC9AFD",
        permission: FlagsPermissionReport.laporan_download_pengiriman.isEnabled()
      }
    ];
  }

  get reportDeliveryPartTwo() {
    return [
      {
        title: this.$t("report.cards.titleScrap"),
        description: "Scrap",
        displayLabel: this.$t("report.cards.descScrap"),
        color: "#C8BBA7",
        permission: FlagsPermissionReport.laporan_download_scrap.isEnabled()
      },
      {
        title: this.$t("report.cards.titlePengirimanKeluar"),
        description: "Pengiriman Keluar (Kota Asal)",
        displayLabel: this.$t("report.cards.descPengirimanKeluar"),
        color: "#FF7474",
        permission: FlagsPermissionReport.laporan_download_pengiriman_keluar.isEnabled()
      },
      {
        title: this.$t("report.cards.titlePengirimanMasuk"),
        description: "Pengiriman Masuk (Kota Tujuan)",
        displayLabel: this.$t("report.cards.descPengirimanMasuk"),
        color: "#FFCB01",
        permission: FlagsPermissionReport.laporan_download_pengiriman_masuk.isEnabled()
      }
    ];
  }

  get reportDeliveryPartThree() {
    return [
      {
        title: this.$t("report.cards.titleKomisiPengiriman"),
        description: "Komisi Pengiriman",
        displayLabel: this.$t("report.cards.descKomisiPengiriman"),
        color: "#F09035",
        permission: FlagsPermissionReport.laporan_download_komisi_pengiriman.isEnabled()
      },
      {
        title: this.$t("report.cards.titleKomisiPengirimanTierX"),
        description: "DTPOL Tier X",
        displayLabel: this.$t("report.cards.descDtpolTierX"),
        color: "#FF7474",
        permission: FlagsPermissionReport.laporan_download_komisi_pengiriman_tier_x.isEnabled()
      }
    ];
  }

  get reportDelivery() {
    return [
      ...this.reportDeliveryPartOne,
      ...this.reportDeliveryPartTwo,
      ...this.reportDeliveryPartThree
    ];
  }

  onGetReportList() {
    this.tmpReportListData = [
      {
        title: this.$t("report.category.stt"),
        detail: this.reportStt,
        totalCard: this.reportStt.filter((card) => card.permission).length
      },
      {
        title: this.$t("report.category.finance"),
        detail: this.reportFinance,
        totalCard: this.reportFinance.filter((card) => card.permission).length
      },
      {
        title: this.$t("report.category.delivery"),
        detail: this.reportDelivery,
        totalCard: this.reportDelivery.filter((card) => card.permission).length
      }
    ];
  }

  isModalDownload = false;
  detailData = null;
  onModalDownload(data: any) {
    this.detailData = data;
    this.isModalDownload = true;

    if (
      data.title === this.$t("report.cards.titleSttReport") &&
      !ReportController.lastSyncHasClicked
    ) {
      ReportController.getLastSyncSttReport();
    }
  }

  get isForeignAccount() {
    return AccountController.accountData.accountIsForeign;
  }

  get isAccountDataEntry() {
    return (
      AccountController.accountData.role_type?.toLowerCase() ===
      "data entry konsolidator"
    );
  }

  get internalWithoutDataEntry() {
    return this.isInternal && !this.isAccountDataEntry;
  }
}
